import { render, staticRenderFns } from "./ModalVisualizarHistorico.vue?vue&type=template&id=04537253&lang=pug"
import script from "./ModalVisualizarHistorico.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarHistorico.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizarHistorico.vue?vue&type=style&index=0&id=04537253&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports